const types = {
    COACHING_LIST: "COACHING_LIST",
    COACHING_LIST_RESPONSE: "COACHING_LIST_RESPONSE",
    COACHING_LIST_CLEAR: "COACHING_LIST_CLEAR",
};
  
export default types;